import NewsSkeleton from "./news-skeleton"

export default function NewsListSkeleton() {
  return (
    <div className="px-4">
      {Array.from({ length: 2 }).map((_, index) => (
        <NewsSkeleton key={index} />
      ))}
    </div>
  )
}
